import {INIT_GOOGLE_PHOTOS, RECEIVE_GOOGLE_PHOTOS_IMAGES} from "../constants/ActionTypes";

export const initGooglePhotos = (connectUrl) => ({
  type: INIT_GOOGLE_PHOTOS,
  connectUrl
})


export const receiveGooglePhotosImages = (images, nextPageToken) => ({
  type: RECEIVE_GOOGLE_PHOTOS_IMAGES,
  images,
  nextPageToken
})
